import { useSelector } from 'react-redux';
import {getActiveProfile} from "../selectors";

const useActiveProfile = () => {
    return useSelector(getActiveProfile)
};

export default useActiveProfile;
